import { AppShell } from "@mantine/core";
import { Outlet, Navigate } from "react-router-dom";
import { UseAuth } from "/@/contexts";
import { Navbar, AccessDenied } from "/@/components/";
import { AppUpdateBanner, STYLE, UserType } from "@jasper/shared";
import { useAppUpdate } from "@jasper/use-cases";
import "./layout.css";
import { OrderListFilterProvider } from "./pages/home/contexts/OrderListFilterContext";
const Layout = () => {
  const { user } = UseAuth();
  const { isUpdateAvailable, updateApp } = useAppUpdate();

  if (!user?.id) {
    return <Navigate to="/" replace={true} />;
  }

  if (user?.type !== UserType.SUPPLIER && user?.type !== UserType.JASPER) {
    return <AccessDenied />;
  }

  return (
    <OrderListFilterProvider>
      {isUpdateAvailable && <AppUpdateBanner onUpdate={updateApp} />}
      {(import.meta.env.MODE === "development" ||
        import.meta.env.MODE === "staging") && (
        <div
          id="mode-display"
          style={{
            color: "white",
            textAlign: "center",
            backgroundColor: STYLE.primary,
            paddingBottom: "1rem",
            paddingTop: "1rem",
          }}
        >
          {import.meta.env.MODE}
        </div>
      )}
      <AppShell
        id="app-shell"
        navbar={{
          width: "18rem",
          breakpoint: "sm",
        }}
        padding="md"
      >
        <AppShell.Navbar
          id="mainMenuDiv"
          p="md"
          style={{
            backgroundColor: "#F2F3F9",
            overflowY: "auto",
            scrollbarGutter: "stable",
          }}
        >
          <Navbar />
        </AppShell.Navbar>
        <AppShell.Main>
          <Outlet />
        </AppShell.Main>
      </AppShell>
    </OrderListFilterProvider>
  );
};

export default Layout;
